import dayjs from 'dayjs';

const addLeadingZero = (num) => {
  return (num < 10 ? '0' : '') + num;
};

const formatHour = (hour) => {
  if (hour > 24) {
    hour = hour - 24;
  }

  return `${addLeadingZero(hour)}:00`;
};

const timeDiff = (from, to, unit) => {
  return dayjs(from).diff(to, unit);
};

const timeAdd = (from, value, unit) => {
  return dayjs(from).add(value, unit).valueOf();
};

const startOf = (from, unit) => {
  return dayjs(from).startOf(unit).valueOf();
};

const endOf = (from, unit) => {
  return dayjs(from).endOf(unit).valueOf();
};

const getRoundedDate = (timestamp = 0, date = new Date()) => {
  return new Date(Math.round(date.getTime() / timestamp) * timestamp);
};

const spreadTime = (seconds) => {
  if (isNaN(seconds)) {
    seconds = 0;
  }

  return {
    hh: addLeadingZero(Math.floor(seconds / 3600)),
    mm: addLeadingZero(Math.floor(seconds / 60) % 60),
    ss: addLeadingZero(Math.floor(seconds) % 60),
  };
};

const timeFormatCountdown = (seconds) => {
  const { hh, mm, ss } = spreadTime(seconds);

  if (hh !== '00') {
    return `${hh}H ${mm}M`;
  }

  return `${mm}M ${ss}S`;
};

const timeFormatExclusive = (seconds) => {
  const { hh, mm, ss } = spreadTime(seconds);

  if (hh !== '00') {
    return `${hh}:${mm}:${ss}`;
  }

  return `${mm}:${ss}`;
};

export default (seconds) => {
  if (isNaN(seconds)) {
    seconds = 0;
  }

  const hh = addLeadingZero(Math.floor(seconds / 3600));
  const mm = addLeadingZero(Math.floor(seconds / 60) % 60);
  const ss = addLeadingZero(Math.floor(seconds) % 60);

  return `${hh}:${mm}:${ss}`;
};

export { timeFormatCountdown };
export { addLeadingZero };
export { timeDiff };
export { timeAdd };
export { startOf };
export { endOf };
export { getRoundedDate };
export { formatHour };
export { timeFormatExclusive };
